import { Ajax } from '../Ajax/Ajax.js';
import {
	initDatepickers,
	initGuests,
	initTimePickers,
	initFormMulti,
	initCounters,
	initTabs,
	initNumberDropdown,
	initCarGallery,
	popupManager
} from '../_Common/app.js';

export class CRM {
	constructor() {
		this.invoiceId = null;
		this.ajax = new Ajax();

		// Настройки автообновления
		this.autoRefreshConfig = {
			enabled: true, // Включаем автообновление
			interval: 30000, // 30 секунд
			timer: null,
			isPageVisible: true,
			lastUpdate: 0,
			initialized: false,
			eventsBound: false
		};
	}

	init() {
		this.invoiceId = $('#orderId').val();
		if ($('aside.page-order').length)
		{
			this.sideshift = true;
			this.initAutoRefresh();
		}
		else
		{
			this.sideshift = false;
		}

		// Привязываем обработчики для статического контента на странице
		// В том числе для попапов, которые рендерятся сразу
		const pageOrder = document.querySelector('.page.order');
		if (pageOrder) {
			this.bindEvents(pageOrder);
		}
	}

	// ===== МЕТОДЫ ДЛЯ РАБОТЫ С ЗАКАЗАМИ =====

	async requestToOrder(id) {
		const response = await this.ajax.post('/ajax.php?mid=47', {
			action: 'requestToOrder',
			id: id,
			invoiceId: this.invoiceId
		});

		if (this.sideshift)
		{
			await this.refreshOrderServices();
		}
		else
		{
			order.update();
		}

		popupManager.closeAll();
	}

	async hideRequest(id) {
		const response = await this.ajax.post('/ajax.php?mid=47', {
			action: 'hideRequest',
			id: id
		});

		if (this.sideshift)
		{
			await this.refreshOrderServices();
			this.switchToRequestsTab();
		}
		else
		{
			order.update();
		}

		popupManager.closeAll();
	}

	async cancelRequest(id) {
		const response = await this.ajax.post('/ajax.php?mid=47', {
			action: 'cancelRequest',
			id: id
		});

		if (this.sideshift)
		{
			await this.refreshOrderServices();
			this.switchToRequestsTab();
		}
		else
		{
			order.update();
		}

		popupManager.closeAll();
	}

	async deleteBlock(table, id) {
		const response = await this.ajax.post('/ajax.php?mid=47', {
			action: 'deleteBlock',
			table: table,
			id: id
		});

		if (this.sideshift)
		{
			await this.refreshOrderServices();
			//this.switchToRequestsTab();
		}
		else
		{
			order.update();
		}

		popupManager.closeAll();
	}

	// ===== МЕТОДЫ ДЛЯ ДОБАВЛЕНИЯ СЕРВИСОВ В ЗАКАЗ =====

	/**
	 * Добавляет сервис в заказ
	 * @param {HTMLElement} button - кнопка, которая была нажата
	 */
	async addToOrder(button) {
		try {
			// Находим форму в попапе
			const form = $(button).closest('.popup__content').find('form')[0];
			if (!form) {
				throw new Error('Форма не найдена');
			}

			// Собираем данные из формы
			const formData = new FormData(form);

			// Добавляем необходимые параметры
			const data = {
				action: 'addToOrder',
				table: form.querySelector('input[name="table"]')?.value,
				blockId: form.querySelector('input[name="blockId"]')?.value,
				invoiceId: this.invoiceId
			};

			// Добавляем все данные из формы
			for (const [key, value] of formData.entries()) {
				data[key] = value;
			}

			console.log('Добавление сервиса в заказ:', data);

			// Отправляем AJAX запрос
			const response = await this.ajax.post('/ajax.php?mid=47', data);

			console.log('Сервис успешно добавлен в заказ');

			// Если был создан новый заказ, обновляем ID и ссылки
			if (response.new_order) {
				console.log('Создан новый заказ с ID:', response.new_order);
				this.invoiceId = response.new_order;

				// Обновляем скрытое поле orderId, если оно существует
				const orderIdInput = document.getElementById('orderId');
				if (orderIdInput) {
					orderIdInput.value = response.new_order;
				}

				// Обновляем все ссылки с параметром order
				this.updateOrderLinks(response.new_order);
			}

			// Обновляем список сервисов
			await this.refreshOrderServices();

			// Закрываем попап
			popupManager.closeAll();

		} catch (error) {
			console.error('Ошибка добавления сервиса в заказ:', error);
			alert('Ошибка при добавлении сервиса в заказ: ' + error.message);
		}
	}

	/**
	 * Отправляет запрос на сервис
	 * @param {HTMLElement} button - кнопка, которая была нажата
	 */
	async sendServiceRequest(button) {
		try {
			// Находим форму в попапе
			const form = button.closest('form');
			if (!form) {
				throw new Error('Форма не найдена');
			}

			// Собираем данные из формы
			const formData = new FormData(form);

			// Добавляем необходимые параметры
			const data = {
				action: 'sendRequest',
				table: form.querySelector('input[name="table"]')?.value,
				blockId: form.querySelector('input[name="blockId"]')?.value,
				invoiceId: this.invoiceId
			};

			// Добавляем все данные из формы
			for (const [key, value] of formData.entries()) {
				data[key] = value;
			}

			console.log('Отправка запроса на сервис:', data);

			// Отправляем AJAX запрос
			const response = await this.ajax.post('/ajax.php?mid=47', data);

			console.log('Запрос на сервис успешно отправлен');

			// Обновляем список сервисов
			await this.refreshOrderServices();

			// Переключаемся на вкладку запросов
			this.switchToRequestsTab();

			// Закрываем попап
			popupManager.closeAll();

		} catch (error) {
			console.error('Ошибка отправки запроса на сервис:', error);
			alert('Ошибка при отправке запроса: ' + error.message);
		}
	}

	async showHideBlock(table, id, el) {
		const response = await this.ajax.post('/ajax.php?mid=47', {
			action: 'showHideBlock',
			table: table,
			id: id,
			invoiceId: this.invoiceId,
			val: $(el).prop('checked')
		});
		order.update();
	}

	async bookOrder(id) {
		try {
			const response = await this.ajax.post('/ajax.php?mid=47', {
				action: 'bookOrder',
				id: id
			});

			if (response.success)
			{
				// Показываем попап успешного бронирования
				this.showOrderSuccess();
			}
			else
			{
				alert(response.error);
			}
		} catch (error) {
			console.error('Ошибка бронирования заказа:', error);
			alert('Ошибка при бронировании заказа: ' + error.message);
		}
	}

	async deleteOrder(id) {
		try {
			const response = await this.ajax.post('/ajax.php?mid=47', {
				action: 'deleteOrder',
				id: id
			});

			if (response.success)
			{
				// Показываем попап успешного удаления
				this.showOrderDeleteSuccess();
			}
			else
			{
				alert(response.error);
			}
		} catch (error) {
			console.error('Ошибка удаления заказа:', error);
			alert('Ошибка при удалении заказа: ' + error.message);
		}
	}

	async restoreOrder(id) {
		try {
			const response = await this.ajax.post('/ajax.php?mid=47', {
				action: 'restoreOrder',
				id: id
			});

			if (response.success)
			{
				// Показываем попап успешного восстановления
				this.showOrderRestoreSuccess();
			}
			else
			{
				alert(response.error);
			}
		} catch (error) {
			console.error('Ошибка восстановления заказа:', error);
			alert('Ошибка при восстановлении заказа: ' + error.message);
		}
	}

	/**
	 * Показывает попап успешного бронирования
	 */
	showOrderSuccess() {
		// Подписываемся на событие закрытия попапа для перезагрузки страницы
		const handlePopupClosed = (popupName) => {
			if (popupName === 'order-success') {
				// Отписываемся от события
				popupManager.off('popupClosed', handlePopupClosed);
				// Перезагружаем страницу
				location.reload();
			}
		};

		popupManager.on('popupClosed', handlePopupClosed);

		// Открываем попап
		popupManager.open('order-success');
	}

	/**
	 * Показывает попап успешного удаления заказа
	 */
	showOrderDeleteSuccess() {
		// Открываем попап (переход на список заказов через кнопку в попапе)
		popupManager.open('popup-order-delete-success');
	}

	/**
	 * Показывает попап подтверждения восстановления заказа
	 */
	showRestoreOrderPopup() {
		popupManager.open('popup-restore-order');
	}

	/**
	 * Показывает попап успешного восстановления заказа
	 */
	showOrderRestoreSuccess() {
		// Подписываемся на событие закрытия попапа для перезагрузки страницы
		const handlePopupClosed = (popupName) => {
			if (popupName === 'order-restore-success') {
				// Отписываемся от события
				popupManager.off('popupClosed', handlePopupClosed);
				// Перезагружаем страницу
				location.reload();
			}
		};

		popupManager.on('popupClosed', handlePopupClosed);

		// Открываем попап
		popupManager.open('order-restore-success');
	}

	/**
	 * Показывает попап успешной отправки платежек
	 */
	showOrderUploadPaymentsSuccess() {
		// Открываем попап
		popupManager.open('popup-order-upload-payments-success');
	}

	/**
	 * Показывает попап успешной оплаты с депозита
	 */
	showOrderPayFromDepositSuccess() {
		// Открываем попап
		popupManager.open('popup-order-pay-from-deposit-success');
	}

	/**
	 * Показывает попап успешной аннуляции заказа
	 */
	showOrderCancellationSuccess() {
		// Открываем попап
		popupManager.open('popup-order-cancellation-success');
	}

	/**
	 * Показывает попап аннуляции заказа
	 * @param {number} id - ID заказа
	 */
	async showCancellationPopup(id) {
		try {
			console.log('Загрузка попапа аннуляции заказа:', id);

			// Отправляем AJAX запрос для получения попапа аннуляции
			const response = await this.ajax.post('/ajax.php?mid=47', {
				action: 'showCancellationPopup',
				id: id
			}, {
				dataType: 'html'
			});

			// Заменяем содержимое попапа или вставляем новый
			const existingPopup = document.querySelector('.order-cancellation');
			if (existingPopup) {
				existingPopup.outerHTML = response;
			} else {
				document.body.insertAdjacentHTML('beforeend', response);
			}

			const newPopup = document.querySelector('.order-cancellation');
			if (newPopup) {
				// Привязываем события
				this.bindEvents(newPopup);

				// Даём браузеру время отрендерить попап перед открытием для плавной анимации
				requestAnimationFrame(() => {
					popupManager.open('order-cancellation');
				});
			}

			console.log('Попап аннуляции заказа загружен успешно');
		} catch (error) {
			console.error('Ошибка загрузки попапа аннуляции:', error);
			alert('Ошибка при загрузке формы аннуляции: ' + error.message);
		}
	}

	/**
	 * Показывает попап управления оплатами
	 * @param {number} id - ID заказа
	 */
	async showPayPopup(id) {
		try {
			console.log('Загрузка попапа управления оплатами:', id);

			// Отправляем AJAX запрос для получения попапа оплаты
			const response = await this.ajax.post('/ajax.php?mid=47', {
				action: 'showPayPopup',
				id: id
			}, {
				dataType: 'html'
			});

			// Заменяем содержимое попапа или вставляем новый
			const existingPopup = document.querySelector('.order-pay');
			if (existingPopup) {
				existingPopup.outerHTML = response;
			} else {
				document.body.insertAdjacentHTML('beforeend', response);
			}

			const newPopup = document.querySelector('.order-pay');
			if (newPopup) {
				// Привязываем события
				this.bindEvents(newPopup);

				// Даём браузеру время отрендерить попап перед открытием для плавной анимации
				requestAnimationFrame(() => {
					popupManager.open('popup-order-pay');
				});
			}

			console.log('Попап управления оплатами загружен успешно');
		} catch (error) {
			console.error('Ошибка загрузки попапа оплаты:', error);
			alert('Ошибка при загрузке формы оплаты: ' + error.message);
		}
	}

	// ===== МЕТОДЫ УПРАВЛЕНИЯ ПОПАПАМИ =====

	/**
	 * Переключает вкладку на "Запросы"
	 */
	switchToRequestsTab() {
		this.setActiveTab('requests');
	}

	// ===== МЕТОДЫ АВТООБНОВЛЕНИЯ =====

	/**
	 * Инициализирует автообновление списка сервисов
	 */
	initAutoRefresh() {
		if (!this.autoRefreshConfig.enabled) return;

		// Проверяем, не инициализировано ли уже автообновление
		if (this.autoRefreshConfig.initialized) {
			console.log('Автообновление уже инициализировано');
			return;
		}

		// Привязываем обработчики событий видимости страницы
		this.bindVisibilityEvents();

		// Запускаем первый таймер
		this.startAutoRefreshTimer();

		// Отмечаем как инициализированное
		this.autoRefreshConfig.initialized = true;

		console.log('Автообновление списка сервисов инициализировано');
	}

	/**
	 * Привязывает обработчики событий видимости страницы
	 */
	bindVisibilityEvents() {
		// Проверяем, не привязаны ли уже обработчики
		if (this.autoRefreshConfig.eventsBound) {
			console.log('Обработчики событий уже привязаны');
			return;
		}

		// Обработчик изменения видимости страницы
		document.addEventListener('visibilitychange', () => {
			if (document.hidden) {
				this.onPageHidden();
			} else {
				this.onPageVisible();
			}
		});

		// Обработчик фокуса окна
		window.addEventListener('focus', () => {
			this.onPageVisible();
		});

		// Обработчик потери фокуса окна
		window.addEventListener('blur', () => {
			this.onPageHidden();
		});

		// Отмечаем, что обработчики привязаны
		this.autoRefreshConfig.eventsBound = true;
		console.log('Обработчики событий видимости привязаны');
	}

	/**
	 * Обработчик скрытия страницы
	 */
	onPageHidden() {
		this.autoRefreshConfig.isPageVisible = false;
		this.stopAutoRefreshTimer();
		console.log('Страница скрыта - автообновление остановлено');
	}

	/**
	 * Обработчик показа страницы
	 */
	onPageVisible() {
		this.autoRefreshConfig.isPageVisible = true;

		// Проверяем, прошло ли достаточно времени с последнего обновления
		const now = Date.now();
		const timeSinceLastUpdate = now - this.autoRefreshConfig.lastUpdate;

		if (timeSinceLastUpdate >= this.autoRefreshConfig.interval) {
			// Если прошло больше времени чем интервал - обновляем сразу
			this.performAutoRefresh();
		} else {
			// Иначе запускаем таймер на оставшееся время
			const remainingTime = this.autoRefreshConfig.interval - timeSinceLastUpdate;
			this.startAutoRefreshTimer(remainingTime);
		}

		console.log('Страница активна - автообновление возобновлено');
	}

	/**
	 * Запускает таймер автообновления
	 * @param {number} customInterval - кастомный интервал (опционально)
	 */
	startAutoRefreshTimer(customInterval = null) {
		if (!this.autoRefreshConfig.enabled || !this.autoRefreshConfig.isPageVisible) return;

		// Очищаем предыдущий таймер
		this.stopAutoRefreshTimer();

		const interval = customInterval || this.autoRefreshConfig.interval;

		this.autoRefreshConfig.timer = setTimeout(() => {
			this.performAutoRefresh();
		}, interval);

		console.log(`Таймер автообновления запущен на ${interval}ms`);
	}

	/**
	 * Останавливает таймер автообновления
	 */
	stopAutoRefreshTimer() {
		if (this.autoRefreshConfig.timer) {
			clearTimeout(this.autoRefreshConfig.timer);
			this.autoRefreshConfig.timer = null;
			console.log('Таймер автообновления остановлен');
		}
	}

	/**
	 * Выполняет автообновление списка сервисов
	 */
	async performAutoRefresh() {
		try {
			console.log('Выполняется автообновление списка сервисов...');

			// Обновляем список сервисов
			await this.refreshOrderServices();

			// Обновляем время последнего обновления
			this.autoRefreshConfig.lastUpdate = Date.now();

			// Запускаем следующий таймер
			this.startAutoRefreshTimer();

			console.log('Автообновление выполнено успешно');
		} catch (error) {
			console.error('Ошибка автообновления:', error);

			// При ошибке запускаем таймер снова через некоторое время
			setTimeout(() => {
				this.startAutoRefreshTimer();
			}, 10000); // Через 10 секунд
		}
	}

	/**
	 * Включает/выключает автообновление
	 * @param {boolean} enabled - включить или выключить
	 */
	setAutoRefreshEnabled(enabled) {
		this.autoRefreshConfig.enabled = enabled;

		if (enabled) {
			this.initAutoRefresh();
		} else {
			this.stopAutoRefreshTimer();
		}

		console.log(`Автообновление ${enabled ? 'включено' : 'выключено'}`);
	}

	/**
	 * Устанавливает интервал автообновления
	 * @param {number} interval - интервал в миллисекундах
	 */
	setAutoRefreshInterval(interval) {
		this.autoRefreshConfig.interval = interval;

		if (this.autoRefreshConfig.enabled && this.autoRefreshConfig.isPageVisible) {
			// Перезапускаем таймер с новым интервалом
			this.stopAutoRefreshTimer();
			this.startAutoRefreshTimer();
		}

		console.log(`Интервал автообновления установлен на ${interval}ms`);
	}

	/**
	 * Обновляет список услуг в заказе
	 */
	async refreshOrderServices() {
		try {
			// Запоминаем активную вкладку перед обновлением
			const activeTab = this.getActiveTab();
			console.log(`Запоминаем активную вкладку перед обновлением: ${activeTab || 'не определена'}`);

			// Отправляем AJAX запрос для обновления списка услуг
			const response = await this.ajax.post('/ajax.php?mid=47', {
				action: 'refreshOrderServices',
				id: this.invoiceId
			}, {
				dataType: 'html'
			});

			// Заменяем всю боковую панель заказа
			const orderAside = $('aside.page__order');
			if (orderAside.length > 0) {
				orderAside.replaceWith(response);

				// Находим новый элемент и привязываем события
				const newOrderAside = $('aside.page__order');
				if (newOrderAside.length > 0) {
					this.bindEvents(newOrderAside[0]);

					// Восстанавливаем активную вкладку
					if (activeTab) {
						this.setActiveTab(activeTab);
					}

					console.log('Список услуг в заказе обновлен и события привязаны');
				}
			} else {
				console.warn('Элемент aside.page__order не найден');
			}
		} catch (error) {
			console.error('Ошибка обновления списка услуг:', error);
		}
	}

	/**
	 * Переключается на другой заказ
	 * @param {string} orderId - ID заказа для переключения
	 */
	async switchOrder(orderId) {
		try {
			console.log(`Переключаемся на заказ: ${orderId}`);

			// Запоминаем активную вкладку перед переключением
			const activeTab = this.getActiveTab();
			console.log(`Запоминаем активную вкладку перед переключением: ${activeTab || 'не определена'}`);

			// Отправляем AJAX запрос для переключения заказа
			const response = await this.ajax.post('/ajax.php?mid=47', {
				action: 'switchOrder',
				id: orderId
			}, {
				dataType: 'html'
			});

			// Заменяем всю боковую панель заказа новым содержимым
			const orderAside = $('aside.page__order');
			if (orderAside.length > 0) {
				orderAside.replaceWith(response);

				// Обновляем текущий ID заказа
				this.invoiceId = orderId;

				// Находим новый элемент и привязываем события
				const newOrderAside = $('aside.page__order');
				if (newOrderAside.length > 0) {
					this.bindEvents(newOrderAside[0]);

					// Восстанавливаем активную вкладку
					if (activeTab) {
						this.setActiveTab(activeTab);
					}

					console.log(`Успешно переключено на заказ ${orderId}, события привязаны`);
				}
			} else {
				console.warn('Элемент aside.page__order не найден');
			}
		} catch (error) {
			console.error('Ошибка переключения заказа:', error);
			alert('Ошибка при переключении заказа: ' + error.message);
		}
	}

	/**
	 * Получить активную вкладку
	 * @returns {string|null} название активной вкладки ('order' или 'requests')
	 */
	getActiveTab() {
		const activeTabBtn = document.querySelector('.page-order__tabs-nav-btn.active');
		if (activeTabBtn) {
			return activeTabBtn.getAttribute('data-tab');
		}
		return null;
	}

	/**
	 * Установить активную вкладку
	 * @param {string} tabName - название вкладки ('order' или 'requests')
	 */
	setActiveTab(tabName) {
		// Убираем активный класс со всех вкладок и кнопок
		document.querySelectorAll('.page-order__tabs-nav-btn').forEach(btn => {
			btn.classList.remove('active');
		});
		document.querySelectorAll('.page-order__tab').forEach(tab => {
			tab.classList.remove('active');
		});

		// Добавляем активный класс на нужную вкладку и кнопку
		const tabBtn = document.querySelector(`.page-order__tabs-nav-btn[data-tab="${tabName}"]`);
		const tabContent = document.querySelector(`.page-order__tab[data-tab="${tabName}"]`);

		if (tabBtn) {
			tabBtn.classList.add('active');
		}
		if (tabContent) {
			tabContent.classList.add('active');
		}

		console.log(`Вкладка "${tabName}" восстановлена как активная`);
	}

	/**
	 * Загружает детали автомобиля и показывает их в попапе
	 * @param {number} carId - ID автомобиля
	 */
	async loadCarDetails(carId) {
		try {
			console.log('Загрузка деталей автомобиля:', carId);

			// Отправляем AJAX запрос для получения деталей автомобиля
			const response = await this.ajax.post('/ajax.php?mid=39', {
				action: 'getCarDetails',
				carId: carId
			}, {
				dataType: 'html'
			});

			// Заменяем содержимое попапа
			const popupCar = document.querySelector('.popup-car');
			if (popupCar) {
				popupCar.outerHTML = response;

				// Привязываем события к новому попапу
				const newPopupCar = document.querySelector('.popup-car');
				if (newPopupCar) {
					this.bindEvents(newPopupCar);

					// Инициализируем галерею через функцию из app.js
					initCarGallery(newPopupCar);

					// Открываем попап через менеджер попапов
					popupManager.open('popup-car');
				}
			}

			console.log('Детали автомобиля загружены успешно');
		} catch (error) {
			console.error('Ошибка загрузки деталей автомобиля:', error);
			alert('Ошибка при загрузке информации об автомобиле: ' + error.message);
		}
	}

	/**
	 * Переключает видимость блока аннуляции
	 * @param {HTMLElement} button - кнопка "Аннулировать сервис"
	 */
	toggleCancellation(button) {
		try {
			// Находим контейнер с кнопкой
			const serviceManagerCancellation = button.closest('.service-manager__cancellation');
			if (!serviceManagerCancellation) {
				console.error('Контейнер кнопки не найден');
				return;
			}

			// Находим блок аннуляции (сосед по родителю)
			const serviceManagerCancellationContent = serviceManagerCancellation.querySelector('.service-manager__cancellation-content');

			if (!serviceManagerCancellationContent) {
				console.error('Блок аннуляции не найден');
				return;
			}

			// Переключаем класс active
			const isActive = serviceManagerCancellationContent.classList.toggle('active');

			// Обновляем текст кнопки
			// const buttonText = button.querySelector('span');
			// if (buttonText) {
			// 	buttonText.textContent = isActive ? 'Скрыть' : 'Аннулировать сервис';
			// }

			// Если блок открылся, скроллим к нему
			if (isActive) {
				// Даем время на анимацию раскрытия, потом скроллим
				setTimeout(() => {
					serviceManagerCancellationContent.scrollIntoView({
						behavior: 'smooth',
						block: 'nearest'
					});
				}, 100);
			}

			console.log(`Блок аннуляции ${isActive ? 'открыт' : 'скрыт'}`);
		} catch (error) {
			console.error('Ошибка переключения блока аннуляции:', error);
		}
	}

	/**
	 * Аннулирует сервис
	 * @param {HTMLElement} button - кнопка подтверждения аннуляции
	 */
	async annulService(button) {
		try {
			// Находим форму
			const form = button.closest('form');
			if (!form) {
				throw new Error('Форма не найдена');
			}

			// Получаем данные из скрытых полей
			const table = form.querySelector('input[name="table"]')?.value;
			const blockId = form.querySelector('input[name="blockId"]')?.value;

			if (!table || !blockId) {
				throw new Error('Не найдены обязательные данные (table или blockId)');
			}

			// Получаем выбранный тип возврата
			const refundTypeInput = form.querySelector('input[name="refund_type"]:checked');
			const refundType = refundTypeInput ? refundTypeInput.value : 'deposit';

			console.log('Аннулирование сервиса:', { table, blockId, refundType });

			// Отправляем AJAX запрос
			await this.ajax.post('/ajax.php?mid=47', {
				action: 'annulService',
				table: table,
				id: blockId,
				refundType: refundType
			});

			console.log('Сервис успешно аннулирован');

			// Обновляем список сервисов
			if (this.sideshift) {
				await this.refreshOrderServices();
			} else {
				order.update();
			}

			// Закрываем попап
			popupManager.closeAll();

		} catch (error) {
			console.error('Ошибка аннулирования сервиса:', error);
			alert('Ошибка при аннулировании сервиса: ' + error.message);
		}
	}

	/**
	 * Аннулирует весь заказ
	 * @param {HTMLElement} button - кнопка подтверждения аннуляции
	 */
	async annulOrder(button) {
		try {
			// Находим форму
			const form = button.closest('form');
			if (!form) {
				throw new Error('Форма не найдена');
			}

			// Получаем ID заказа
			const invoiceId = form.querySelector('input[name="invoiceId"]')?.value;

			if (!invoiceId) {
				throw new Error('Не найден ID заказа');
			}

			// Получаем выбранный тип возврата
			const refundTypeInput = form.querySelector('input[name="refund_type"]:checked');
			const refundType = refundTypeInput ? refundTypeInput.value : 'deposit';

			console.log('Аннулирование заказа:', { invoiceId, refundType });

			// Отправляем AJAX запрос
			await this.ajax.post('/ajax.php?mid=47', {
				action: 'annulOrder',
				id: invoiceId,
				refundType: refundType
			});

			console.log('Заказ успешно аннулирован');

			// Закрываем попап
			popupManager.closeAll();

			// Показываем попап успешной аннуляции
			this.showOrderCancellationSuccess();

		} catch (error) {
			console.error('Ошибка аннулирования заказа:', error);
			alert('Ошибка при аннулировании заказа: ' + error.message);
		}
	}

	/**
	 * Обновляет расчет стоимости визы
	 */
	updateVisaPrice() {
		// Получаем выбранный тип визы
		const selectedType = document.querySelector('input[name="chk_urgent"]:checked');
		if (!selectedType) return;

		// Получаем цену из data-price
		const price = parseFloat(selectedType.getAttribute('data-price')) || 0;

		// Получаем количество
		const countInput = document.querySelector('#num_count');
		if (!countInput) return;

		const count = parseInt(countInput.value) || 1;

		// Вычисляем окончание для слова "виз"
		let end;
		if (count % 10 == 1 && count % 100 != 11) {
			end = 'а';
		} else if ((count % 10 > 1 && count % 10 < 5) && (count % 100 < 11 || count % 100 > 15)) {
			end = 'ы';
		} else {
			end = '';
		}

		// Определяем тип визы для отображения
		const visaType = selectedType.value === '1' ? 'срочная' : 'стандарт';

		// Обновляем отображение
		const quantityEl = document.querySelector('.visa-get__price-quantity');
		const captionEl = quantityEl ? quantityEl.parentNode : null;
		const priceValueEl = document.querySelector('.visa-get__price-value');

		if (quantityEl) {
			quantityEl.textContent = count;
		}

		if (captionEl) {
			// Обновляем текст после количества
			const textNode = Array.from(captionEl.childNodes).find(node => node.nodeType === 3);
			if (textNode) {
				textNode.textContent = ` x виз${end} (${visaType})`;
			}
		}

		if (priceValueEl) {
			priceValueEl.textContent = `$ ${(price * count)}`;
		}
	}

	/**
	 * Универсальная валидация form-multi dropdown
	 * @param {HTMLElement} formMulti - элемент .form-multi
	 * @param {string} errorMessage - сообщение об ошибке
	 * @returns {boolean} true если выбрано значение, false если нет
	 */
	validateFormMulti(formMulti, errorMessage = 'Выберите значение из списка') {
		if (!formMulti) {
			console.error('[CRM] Form-multi элемент не найден');
			return false;
		}

		const displayInput = formMulti.querySelector('.form-multi__top-input');
		const hiddenInputs = formMulti.querySelectorAll('.form-multi__choice-input');
		const formItem = formMulti.closest('.form__item');
		const mistakeEl = formItem ? formItem.querySelector('.form__item-mistake') : null;

		if (!displayInput || !hiddenInputs.length) {
			console.error('[CRM] Элементы form-multi не найдены');
			return false;
		}

		// Проверяем, что выбран хотя бы один radio
		const isSelected = Array.from(hiddenInputs).some(input => input.checked);

		if (!isSelected) {
			// Устанавливаем нативную валидацию
			displayInput.setCustomValidity(errorMessage);
			displayInput.reportValidity();

			// Показываем текст ошибки в .form__item-mistake (закомментировано)
			// if (mistakeEl) {
			// 	mistakeEl.textContent = errorMessage;
			// 	mistakeEl.style.display = 'block';
			// }

			// Открываем список после показа валидации
			setTimeout(() => {
				formMulti.classList.add('active');
			}, 100);

			console.log('[CRM] Валидация form-multi: не прошла');
			return false;
		}

		// Снимаем нативную валидацию и прячем текст ошибки
		displayInput.setCustomValidity('');
		// if (mistakeEl) {
		// 	mistakeEl.textContent = '';
		// 	mistakeEl.style.display = 'none';
		// }

		console.log('[CRM] Валидация form-multi: прошла успешно');
		return true;
	}

	/**
	 * Универсальная валидация datepicker
	 * @param {HTMLElement} datepicker - элемент .datepicker
	 * @param {string} errorMessage - сообщение об ошибке
	 * @returns {boolean} true если дата выбрана, false если нет
	 */
	validateDatepicker(datepicker, errorMessage = 'Выберите дату') {
		if (!datepicker) {
			console.error('[CRM] Datepicker элемент не найден');
			return false;
		}

		const hiddenInput = datepicker.querySelector('.datepicker__value');
		const btn = datepicker.querySelector('.datepicker__main-item-btn');
		const calendar = datepicker.querySelector('.datepicker__calendar');

		if (!hiddenInput || !btn || !calendar) {
			console.error('[CRM] Элементы datepicker не найдены');
			return false;
		}

		// Проверяем, что дата выбрана (скрытое поле не пустое)
		const isSelected = hiddenInput.value && hiddenInput.value.trim() !== '';

		if (!isSelected) {
			// Добавляем класс invalid для красной рамки
			btn.classList.add('invalid');

			// Открываем календарь
			calendar.classList.add('active');
			btn.focus();

			console.log('[CRM] Валидация datepicker: не прошла');
			return false;
		}

		// Убираем класс invalid при успешной валидации
		btn.classList.remove('invalid');

		console.log('[CRM] Валидация datepicker: прошла успешно');
		return true;
	}

	/**
	 * Универсальная валидация формы
	 * @param {HTMLFormElement} form - форма для валидации
	 * @returns {boolean} true если форма валидна, false если нет
	 */
	validateForm(form) {
		if (!form) {
			console.error('[CRM] Форма не найдена');
			return false;
		}

		// Валидация всех обязательных form-multi - останавливаемся на первой ошибке
		const requiredFormMultis = form.querySelectorAll('.form-multi');
		for (let formMulti of requiredFormMultis) {
			const displayInput = formMulti.querySelector('.form-multi__top-input');
			if (displayInput && displayInput.hasAttribute('required')) {
				if (!this.validateFormMulti(formMulti)) {
					console.log('[CRM] Валидация формы: остановка на первом невалидном form-multi');
					return false;
				}
			}
		}

		// Валидация всех обязательных datepicker - останавливаемся на первой ошибке
		const requiredDatepickers = form.querySelectorAll('.datepicker[data-required="true"]');
		for (let datepicker of requiredDatepickers) {
			if (!this.validateDatepicker(datepicker)) {
				console.log('[CRM] Валидация формы: остановка на первом невалидном datepicker');
				return false;
			}
		}

		// Валидация всех обязательных time inputs - останавливаемся на первой ошибке
		const requiredTimeInputs = form.querySelectorAll('.form-time__input[required]');
		for (let timeInput of requiredTimeInputs) {
			if (!timeInput.value || timeInput.value.trim() === '') {
				timeInput.reportValidity();
				console.log('[CRM] Валидация формы: остановка на невалидном time input');
				return false;
			}
		}

		// Стандартная HTML5 валидация для остальных полей
		if (!form.checkValidity()) {
			form.reportValidity();
			console.log('[CRM] Валидация формы: HTML5 валидация не прошла');
			return false;
		}

		console.log('[CRM] Валидация формы: успешно');
		return true;
	}

	/**
	 * Валидирует выбор страны паспорта для визы (legacy метод, использует validateFormMulti)
	 * @returns {boolean} true если страна выбрана, false если нет
	 */
	validateVisaCountry() {
		const formMulti = document.querySelector('#visa-country-selector');
		return this.validateFormMulti(formMulti, 'Выберите страну паспорта');
	}

	/**
	 * Добавляет визу в заказ с валидацией
	 */
	async addVisa() {
		console.log('[CRM] Попытка добавить визу');

		// Валидируем выбор страны
		if (!this.validateVisaCountry()) {
			console.log('[CRM] Виза не добавлена - страна не выбрана');
			return;
		}

		console.log('[CRM] Валидация прошла, добавляем визу в заказ');

		// Вызываем serviceManager для создания блока визы
		if (window.serviceManager) {
			await window.serviceManager.createBlock('visas', '1');
		} else {
			console.error('[CRM] ServiceManager не найден');
			alert('Ошибка: ServiceManager не инициализирован');
		}
	}

	/**
	 * Копирует текст предложения в буфер обмена
	 */
	async copyQuotationText() {
		const button = document.querySelector('.order-calc-nav__btn');
		if (!button) return;

		const span = button.querySelector('span');
		const originalText = span.textContent;

		// Получаем дату срока действия предложения из формы
		const offerDeadlineInput = document.querySelector('input[name="dte_offer_deadline"]');
		const offerDeadline = offerDeadlineInput ? offerDeadlineInput.value : '';

		try {
			// Делаем AJAX запрос
			const response = await this.ajax.post('/ajax.php?mid=47', {
				action: 'getQuotationText',
				id: this.invoiceId,
				offerDeadline: offerDeadline
			}, {
				dataType: 'json'
			});

			if (response.success) {
				// Копируем HTML для почты и Markdown для Telegram/WhatsApp
				const clipboardItem = new ClipboardItem({
					'text/html': new Blob([response.html], { type: 'text/html' }),
					'text/plain': new Blob([response.markdown], { type: 'text/plain' })
				});
				await navigator.clipboard.write([clipboardItem]);

				// Меняем текст и стиль кнопки
				span.textContent = 'Скопировано!';
				button.classList.add('order-calc-nav__btn--copied');

				// Через 3 секунды возвращаем обратно
				setTimeout(() => {
					span.textContent = originalText;
					button.classList.remove('order-calc-nav__btn--copied');
				}, 3000);
			} else {
				alert('Ошибка: ' + (response.error || 'Не удалось получить текст предложения'));
			}
		} catch (error) {
			console.error('Ошибка при копировании текста предложения:', error);
			alert('Не удалось скопировать текст предложения. Проверьте консоль для деталей.');
		}
	}

	/**
	 * Переключение типа оплаты (полная/частичная)
	 * @param {HTMLInputElement} radio - radio кнопка выбора типа
	 */
	togglePaymentType(radio) {
		const form = radio.closest('form');
		const addBtn = form.querySelector('.order-pay__add-payment-btn');
		const payType = radio.value;

		if (payType === '2') {
			// Частичная оплата - показываем кнопку добавления
			addBtn.style.display = 'block';
		} else {
			// Полная оплата - скрываем кнопку, оставляем только одно поле
			addBtn.style.display = 'none';
			// Удаляем все дополнительные поля кроме первого
			const fileItems = form.querySelectorAll('.order-pay__file-item');
			fileItems.forEach((item, index) => {
				if (index > 0) {
					item.remove();
				}
			});
		}
	}

	/**
	 * Добавление нового поля для загрузки платежа
	 */
	addPaymentField() {
		const form = document.querySelector('.order-pay__form');
		const fileItems = form.querySelectorAll('.order-pay__file-item');
		const templateItem = fileItems[0];
		const newIndex = fileItems.length;

		// Клонируем первое поле
		const newItem = templateItem.cloneNode(true);
		newItem.setAttribute('data-file-index', newIndex);

		// Обновляем ID и name для input
		const fileInput = newItem.querySelector('.form-file__input');
		const newId = `fle_file_id${newIndex}`;
		fileInput.id = newId;
		fileInput.value = ''; // Очищаем значение
		fileInput.required = false;

		// Обновляем for у label
		const label = newItem.querySelector('.form-file__label');
		label.setAttribute('for', newId);

		// Скрываем results, показываем main
		const fileMain = newItem.querySelector('.form-file__main');
		const fileResults = newItem.querySelector('.form-file__results');
		fileMain.style.display = 'flex';
		fileResults.classList.remove('active');

		// Очищаем имя файла в results
		const fileName = fileResults.querySelector('.form-file__results-item-name');
		if (fileName) fileName.textContent = '';

		// Добавляем inline onchange
		fileInput.setAttribute('onchange', 'crm.handleFileSelect(this)');

		// Вставляем новое поле перед кнопкой добавления
		const addBtnContainer = form.querySelector('.order-pay__add-payment-btn');
		addBtnContainer.parentNode.insertBefore(newItem, addBtnContainer);
	}

	/**
	 * Обработка выбора файла - показываем или скрываем блоки в зависимости от наличия файла
	 * @param {HTMLInputElement} input - file input
	 */
	handleFileSelect(input) {
		const fileItem = input.closest('.order-pay__file-item');
		if (!fileItem) {
			console.error('[CRM] File item not found');
			return;
		}

		const fileMain = fileItem.querySelector('.form-file__main');
		const fileResults = fileItem.querySelector('.form-file__results');
		const fileName = fileResults.querySelector('.form-file__results-item-name');
		const fileLink = fileResults.querySelector('.form-file__results-item-link');

		// Проверяем, есть ли выбранный файл
		const file = input.files[0];

		if (file) {
			// Файл выбран - показываем блок с результатом
			fileName.textContent = file.name;

			// Создаем временную ссылку для скачивания файла
			// Это позволит пользователю скачать файл, который он выбрал, но еще не загрузил на сервер
			const fileURL = URL.createObjectURL(file);
			fileLink.href = fileURL;
			fileLink.download = file.name; // Устанавливаем имя файла для скачивания

			// Сохраняем ссылку на URL, чтобы освободить память при удалении
			fileItem.dataset.fileUrl = fileURL;

			fileMain.style.display = 'none';
			fileResults.classList.add('active');
			console.log('[CRM] File selected:', file.name);
		} else {
			// Файл не выбран - показываем блок загрузки

			// Освобождаем память от старого URL объекта
			if (fileItem.dataset.fileUrl) {
				URL.revokeObjectURL(fileItem.dataset.fileUrl);
				delete fileItem.dataset.fileUrl;
			}

			fileLink.href = '#';
			fileLink.removeAttribute('download');
			fileMain.style.display = 'flex';
			fileResults.classList.remove('active');
			fileName.textContent = '';
			console.log('[CRM] File cleared');
		}
	}

	/**
	 * Очистка выбранного файла
	 * @param {HTMLButtonElement} button - кнопка удаления
	 * @param {Event} event - событие клика
	 */
	clearPaymentFile(button, event) {
		// Останавливаем всплытие события, чтобы не закрывался попап
		if (event) {
			event.preventDefault();
			event.stopPropagation();
		}

		const fileItem = button.closest('.order-pay__file-item');
		const fileInput = fileItem.querySelector('.form-file__input');

		// Если это не первое поле - удаляем его
		const allItems = document.querySelectorAll('.order-pay__file-item');
		if (allItems.length > 1 && fileItem.getAttribute('data-file-index') !== '0') {
			fileItem.remove();
		} else {
			// Для первого поля - просто очищаем значение
			// handleFileSelect сам переключит отображение через событие change
			fileInput.value = '';
			// Вызываем handleFileSelect напрямую, т.к. событие change не срабатывает при программной очистке
			this.handleFileSelect(fileInput);
		}
	}

	/**
	 * Оплата заказа с депозита
	 * @param {number} id - ID заказа
	 */
	async payFromDeposit(id) {
		try {
			console.log('[CRM] Начинаем оплату с депозита для заказа:', id);

			const response = await this.ajax.post('/ajax.php?mid=47', {
				action: 'payFromDeposit',
				id: id
			}, {
				dataType: 'json'
			});

			console.log('[CRM] Ответ сервера:', response);

			if (response.success) {
				console.log('[CRM] Оплата с депозита успешно выполнена');

				// Закрываем попап
				popupManager.closeAll();

				// Обновляем заказ
				if (window.order) {
					await window.order.update();
				}

				// Показываем попап успешной оплаты
				this.showOrderPayFromDepositSuccess();
			} else {
				console.error('[CRM] Ошибка оплаты с депозита:', response.error);
				alert('Ошибка при оплате с депозита: ' + (response.error || 'Неизвестная ошибка'));
			}
		} catch (error) {
			console.error('[CRM] Ошибка при оплате с депозита:', error);
			alert('Произошла ошибка при оплате с депозита');
		}
	}

	/**
	 * Отправка платежей на сервер
	 * @param {HTMLFormElement} form - форма с данными
	 */
	async uploadPayments(form) {
		try {
			console.log('[CRM] Начинаем отправку платежей');

			const formData = new FormData(form);
			formData.append('action', 'uploadPayments');
			formData.append('invoiceId', this.invoiceId);

			console.log('[CRM] Данные для отправки:', {
				action: 'uploadPayments',
				invoiceId: this.invoiceId,
				files: formData.getAll('fle_file[]').length
			});

			// Отправляем через AJAX
			const response = await this.ajax.post('/ajax.php?mid=47', formData, {
				dataType: 'json',
				processData: false,
				contentType: false
			});

			console.log('[CRM] Ответ сервера:', response);

			if (response.success) {
				console.log('[CRM] Платежи успешно загружены');

				// Закрываем попап
				popupManager.closeAll();

				// Обновляем заказ
				if (window.order) {
					await window.order.update();
				}

				// Показываем попап успешной отправки
				this.showOrderUploadPaymentsSuccess();
			} else {
				console.error('[CRM] Ошибка загрузки платежей:', response.error);
				alert('Ошибка при загрузке платежей: ' + (response.error || 'Неизвестная ошибка'));
			}
		} catch (error) {
			console.error('[CRM] Ошибка при отправке платежей:', error);
			alert('Произошла ошибка при отправке платежей');
		}

		return false; // Предотвращаем стандартную отправку формы
	}

	/**
	 * Обновляет все ссылки с параметром order на странице
	 * @param {string} orderId - ID заказа для вставки в ссылки
	 */
	updateOrderLinks(orderId) {
		console.log('Обновление ссылок с ID заказа:', orderId);

		// Находим все ссылки, помеченные для обновления
		const linksToUpdate = document.querySelectorAll('[data-order-link]');

		linksToUpdate.forEach(link => {
			const currentHref = link.getAttribute('href');

			// Создаем URL объект для парсинга
			const url = new URL(currentHref, window.location.origin);

			// Добавляем или обновляем параметр order
			url.searchParams.set('order', orderId);

			// Обновляем href
			link.setAttribute('href', url.pathname + url.search);

			console.log(`Обновлена ссылка: ${currentHref} -> ${url.pathname + url.search}`);
		});

		console.log(`Обновлено ${linksToUpdate.length} ссылок`);
	}

	/**
	 * Привязывает события к загруженному контенту
	 * @param {HTMLElement} container - контейнер с загруженным контентом
	 */
	bindEvents(container) {
		// Инициализируем все интерактивные элементы
		initDatepickers(container);
		initGuests(container);
		initTimePickers(container);
		initFormMulti(container);
		initCounters(container);
		initTabs(container);
		initNumberDropdown(container);
		initCarGallery(container);

		// Привязываем обработчики вкладок
		const tabButtons = container.querySelectorAll('.page-order__tabs-nav-btn');
		tabButtons.forEach(button => {
			const tabName = button.getAttribute('data-tab');
			button.addEventListener('click', () => {
				this.setActiveTab(tabName);
			});
		});

		// Привязываем попапы через PopupManager
		popupManager.bindPopupEvents(container);
	}
}
